<template>
  <div>
    <div class="Model" v-show="popflag">
      <div class="meet2" ref="meet2" :style="{ backgroundImage: `url(${bg})` }">
        <img @click="Close" class="close" src="../assets/close.png" />
        <div class="one" ref="one" v-html="title"></div>
        <div class="line" ref="line"></div>
        <div class="form" ref="form">
          <p>
            <img src="../assets/phone.png" /><input
              v-model="phone"
              type="text"
              class="game-iphone"
              id="game-iphone"
              maxlength="11"
              placeholder="请输入手机号"
            />
          </p>
          <p>
            <img src="../assets/code.png" /><input
              v-model="code"
              type="text"
              class="game-code"
              id="game-code"
              maxlength="6"
              placeholder="短信验证码"
            /><span class="sendPhoneCode3" @click="getCode">{{
              vcodeTxt
            }}</span>
          </p>
        </div>
        <div class="btn" ref="btnnn" @click="opportunity($event)">
          {{ btntxt }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import {
  submitFormSys,
  getVerificationCode,
  getVertialcode,
  registerByCode,
  consumeCoin,
} from "../api/index";
import check from "../../../../utils/check";
export default {
  data() {
    return {
      phone: "",
      code: "",
      secs: 90,
      vcodeDisabled: false,
      title: "dasdas",
      btntxt: "",
      campaignId: "",
      bg: "",
      fistlive: () => {
        if (
          new Date() > new Date("2021/5/10 00:00:00") &&
          new Date() < new Date("2021/5/16 23:59:59")
        ) {
          return true;
        } else {
          return false;
        }
      }, // 第一阶段
      secondlive: () => {
        if (
          new Date() > new Date("2021/5/17 00:00:00") &&
          new Date() < new Date("2021/5/23 23:59:59")
        ) {
          return true;
        } else {
          return false;
        }
      }, //第二阶段
      thirdlive: () => {
        if (
          new Date() > new Date("2021/5/24 00:00:00") &&
          new Date() < new Date("2021/5/31 23:59:59")
        ) {
          return true;
        } else {
          return false;
        }
      }, //第三阶段
    };
  },
  methods: {
    ...mapMutations(["Closepop", "Opensuccesspop"]),
    Close() {
      this.phone = "";
      this.code = "";
      this.Closepop();
      this.vcodeDisabled = false;
    },
    // 获取地址栏参数
    getQueryString(key) {
      var url = window.location.search;
      var reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)");
      var result = url.substr(1).match(reg);
      return result ? decodeURIComponent(result[2]) : null;
    },
    async opportunity(e) {
      if (check.checkphoneNull(this.phone))
        return this.$toast.show("请输入手机号");
      if (check.checksmsCodeNull(this.code))
        return this.$toast.show("请输入验证码");
      if (!check.checksmsCode(this.code))
        return this.$toast.show("请输入正确验证码");
      if (!check.checkPhone(this.phone))
        return this.$toast.show("请输入正确手机号");
      this.$mai(2, e);
      const { phone, code, campaignId } = this;

      const data = await registerByCode({
        userName: phone,
        code: code,
        rememberMe: true,
        loginTerminal: "h5",
      });
      if (data.status == 200) {
        if (this.poptype == 4) {
          const res = await consumeCoin(
            {
              activityId: "may_S5C81THFGYKZ",
              userId: data.result.uid,
              activityType: 1,
              operateType: 1,
              taskType: 8,
            },
            data.result.sign
          );
          localStorage.setItem("sign", data.result.sign);
          localStorage.setItem("uid", data.result.uid);
          this.Close();
          this.$toast.show("登录成功");
          this.$emit("Get");
          document.querySelector("#islog").style.display = "block";
          document.querySelector("#nolog").style.display = "none";
          return;
        }
        //   // 提交表单
        const { status } = await submitFormSys({
          realname: phone,
          mobile: phone,
          activity_id: 20210420,
          blog_url: this.getQueryString("utm_source") || "",
          googleplus: zhuge.getSid() + "&" + zhuge.getDid(),
          extend1: phone,
        });
        if (status == "success" && this.poptype == 1) {
          const { status } = await getVertialcode({
            name: phone,
            mobile: phone,
            verificationCode: code,
            campaignId,
            blog_url: this.getQueryString("utm_source") || "",
          });
          if (status == 200) {
            this.Close();
            this.Opensuccesspop();
          }
        } else {
          this.Close();
          this.Opensuccesspop();
        }
      } else {
        this.$toast.show(data.message);
      }
    },

    //   获取验证码
    async getCode() {
      if (check.checkphoneNull(this.phone))
        return this.$toast.show("请输入手机号");
      if (!check.checkPhone(this.phone))
        return this.$toast.show("请输入正确手机号");
      // 获取验证码接口
      const { success } = await getVerificationCode({ phoneNo: this.phone });
      if (success == true) {
        // 验证码倒计时
        this.vcodeDisabled = true;
        this._CutTimer();
        this.$mai(2, null, "获取验证码");
      } else {
        this.$toast.show("同一手机号两次发送间隔至少90秒！");
      }
    },
    //倒计时
    _CutTimer() {
      this.vcodeTimer = setTimeout(() => {
        --this.secs;
        if (this.secs > 0) {
          this._CutTimer();
        } else {
          this.vcodeDisabled = false;
          this.secs = 90;
          clearTimeout(this.vcodeTimer);
        }
      }, 1000);
    },
  },
  computed: {
    vcodeTxt() {
      if (!this.vcodeDisabled) {
        return "获取验证码";
      } else if (this.secs == 90) {
        return "发送中...";
      } else {
        return `${this.secs}s`;
      }
    },
    ...mapState(["popflag", "poptype", "convertType"]),
  },
  watch: {
    // 判断弹窗类型
    poptype(value) {
      switch (value) {
        case 1:
          this.$refs.meet2.style.height = "7.946667rem";
          this.$refs.form.style.marginTop = "0.53333rem";
          this.$refs.one.style.marginTop = "1.46666rem";
          this.$refs.btnnn.style.marginTop = "0.64rem";

          this.bg = require("../assets/popbg.png");
          if (this.fistlive()) {
            this.title = "2000元SVIP新课优惠劵";
            this.campaignId = "770E2DE6D21FE8E4";
          } else if (this.secondlive()) {
            this.title = "1200元SVIP新课优惠劵";
            this.campaignId = "19C9AFE84B179459";
          } else if (this.thirdlive()) {
            this.title = "500元SVIP新课优惠劵";
            this.campaignId = "CA9EA01570F9620F";
          }
          this.btntxt = "立即领取";
          break;
        case 2:
          this.$refs.meet2.style.height = "7.946667rem";
          this.$refs.form.style.marginTop = "0.53333rem";
          this.$refs.one.style.marginTop = "1.46666rem";
          this.$refs.btnnn.style.marginTop = "0.44rem";

          this.bg = require("../assets/popbg.png");
          this.title = "购年度会员<br/>享《360°就业通》5折";
          this.btntxt = "立抢5折优惠";
          break;
        case 3:
          this.$refs.meet2.style.height = "7.946667rem";
          this.$refs.form.style.marginTop = "0.53333rem";
          this.$refs.one.style.marginTop = "1.46666rem";
          this.$refs.btnnn.style.marginTop = "0.64rem";

          this.bg = require("../assets/popbg.png");
          this.title = "学习路线图限时免费啦";
          this.btntxt = "立即申请";
          break;
        case 4:
          this.$refs.meet2.style.height = "7.946667rem";
          this.$refs.form.style.marginTop = "0.53333rem";
          this.$refs.one.style.marginTop = "1.46666rem";
          this.$refs.btnnn.style.marginTop = "0.64rem";

          this.bg = require("../assets/login.png");
          this.title = "快速登录";
          this.btntxt = "登录";
          break;
        case 6:
          this.$refs.meet2.style.height = "7.1333rem";
          this.$refs.one.style.marginTop = "0.6533rem";
          this.$refs.form.style.marginTop = "0.78667rem";
          this.$refs.btnnn.style.marginTop = "0.64rem";

          this.bg = require("../assets/duihuan.png");
          this.title = "积小谷币兑换好礼";
          this.btntxt = "立即兑换";
          break;
        case 8:
          this.$refs.meet2.style.height = "7.946667rem";
          this.$refs.form.style.marginTop = "0.53333rem";
          this.$refs.one.style.marginTop = "1.46666rem";
          this.$refs.btnnn.style.marginTop = "0.64rem";

          this.bg = require("../assets/popbg.png");
          this.title = "5大重磅福利感恩回馈";
          this.btntxt = "立抢福利";
          break;
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.Model {
  // height: .786667rem;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 999;
}
.meet {
  .close {
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    bottom: -80px;
    width: 52px;
    height: 52px;
  }
  .btn {
    font-weight: bold;
    margin: 0 auto;
    margin-top: 18px;
    text-align: center;
    width: 420px;
    height: 70px;
    background-image: url("../assets/btn.png");
    background-size: 100% 100%;
    font-size: 30px;
    line-height: 70px;
    color: #5530fd;
  }
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 560px;
  height: 731px;
  background-size: cover;
  .one {
    text-align: center;
    margin-top: 110px;
    font-weight: normal;
    font-size: 36px;
    color: #ff4133;
    font-weight: bold;
  }
  .line {
    width: 540px;
    height: 2px;
    background-color: #5530fd;
    opacity: 0.3;
    margin-top: 30px;
  }
  .two {
    text-align: center;
    margin-top: 28px;
    font-size: 30px;
    letter-spacing: 2px;
    color: #ff4133;
  }
  .form {
    margin-top: 40px;
    p {
      overflow: hidden;
      margin: 0 auto;
      width: 420px;
      height: 71px;
      border-radius: 6px;
      border: solid 2px #2549ff;
      box-sizing: border-box;
      padding-left: 38px;
      text-align: left;
      display: flex;
      align-items: center;
      background-color: #ffffff;
      span {
        text-align: center;
        width: 184px;
        height: 88px;
        border-radius: 20px;
        font-size: 24px;
        line-height: 71px;
        color: #5530fd;
      }
      input {
        border: none;
        outline: none;
        height: 80%;
        width: 300px;
        margin-bottom: 0px;
      }
    }
    p:nth-of-type(1) {
      img {
        margin-right: 12px;
        width: 22px;
        height: 32px;
      }
    }
    p:nth-of-type(2) {
      margin-top: 30px;
      img {
        margin-right: 12px;
        width: 26px;
        height: 33px;
      }
      input {
        width: 55%;
      }
      span {
        height: 100%;
      }
    }
  }
}
.meet2 {
  @extend .meet;
  //   background-image: url("../assets/popbg.png");
  width: 540px;
  height: 596px;
  background-size: 100% 100%;
  .btn {
    // margin-top: 48px !important;
    margin-top: 48px;
  }
}
</style>